<template>
  <div>
    <b-loading
        v-model="isLoading"
        :can-cancel="false"
        :is-full-page="true"
    ></b-loading>
    <div style="background: #eeeeee;padding-bottom: 120px">
      <div class="is-flex m-0 p-0">
        <div class="video-img" style="width: 50%; line-height: 0; position: relative">
          <video id="vid" ref="videoRef"
                 :src="selectedCalibration && selectedCalibration.videoUrl ? selectedCalibration.videoUrl : selectedDevice ? selectedDevice.videoUrl : ''"
                 @loadedmetadata="onVideoMetaDataLoaded" loop=""
                 preload="auto"
                 muted="" style="width: 100%;"></video>
          <div class="canvas-style" ref="canvas">
            <draw-on-video ref="videoDraw" @onDrawFinished="onDrawFinished" @onPlayVideo="onPlayPauseVideo"
                           :is-video-playing="isVideoPlaying" :is-video-loaded="videoLoaded"
                           @onDeleteImage="onDeleteImage" @onColorChanged="onColorChanged"
                           :video-start="getVideoStart()" :video-end="getVideoEnd()" @onVideoChanged="onVideoChanged"
                           :tabIndex="tabIndex"></draw-on-video>
          </div>
        </div>
        <div class="m-0 p-0 video-img" style="width: 50%; border: none">
          <draw-map ref="mapDraw" @onLinesDrawn="onLinesDrawn" :selected-tab="tabIndex"></draw-map>
        </div>
      </div>
      <actions-bar ref="actionsBar" @onSaveData="saveData" @onCloseCalibration="onCloseCalibration"></actions-bar>
      <div v-if="selectedCalibration" class="m-4 mb-6 pb-6 box" style="min-height: 500px;">
        <b-tabs type="is-toggle" v-model="tabIndex" @input="onTabChanged">
          <b-tab-item label="Stage Polygons" icon="vector-polygon-variant">
            <div>
              <hr class="mt-3 mb-4 has-background-grey-light mr-0" style="height: 1px">
              <div class="card shadow mb-3" v-for="polygon in videoData.stagePolygons" :key="polygon.id">
                <div class="is-flex p-3 pt-3 columns m-0">
                  <div class="column is-2 m-0 p-0">
                    <b-field label="Polygon Name" label-position="on-border" class="mr-2">
                      <b-input placeholder="Polygon Name" rounded type="text" size="is-small"
                               :disabled="!selectedCalibration || !selectedCalibration.isNew"
                               v-model="polygon.storeData.polyName" @input="onPolyDataChanged"></b-input>
                    </b-field>
                  </div>
                  <div class="column is-4 m-0 p-0">
                    <b-field label="Coordinates" label-position="on-border">
                      <b-input placeholder="Coordinates" rounded type="text" size="is-small"
                               :disabled="!selectedCalibration || !selectedCalibration.isNew"
                               v-model="polygon.ptsString"></b-input>
                    </b-field>
                  </div>
                  <div class="column is-2 m-0 p-0">
                    <div class="m-0 ml-3 p-0">
                      <div class="has-text-grey-light has-text-weight-normal" style="font-size: 10px;">CROSSING
                        DISTANCE
                      </div>
                      <div class="has-text-black has-text-weight-semibold" style="line-height: 1; font-size: 12px">
                        {{ polygon.storeData.crossingDistance ? polygon.storeData.crossingDistance : '-' }}
                      </div>
                    </div>
                  </div>
                  <div class="column is-4 m-0 p-0 is-flex">
                    <b-button icon-left="delete" size="is-small" class="ml-auto" @mouseover="onHover(polygon.id)"
                              @mouseleave="onLeave(polygon.id)" @click="onDelete(polygon.id)"></b-button>
                  </div>
                </div>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="Direction Polygons" icon="vector-polygon-variant">
            <div>
              <hr class="mt-3 mb-4 has-background-grey-light mr-0" style="height: 1px">
              <div class="card shadow mb-3" v-for="polygon in videoData.directionPolygons" :key="polygon.id">
                <div class="is-flex p-3 pt-3 columns m-0">
                  <div class="column is-2 m-0 p-0">
                    <b-field label="Polygon Name" label-position="on-border" class="mr-2">
                      <b-input placeholder="Polygon Name" rounded type="text" size="is-small"
                               :disabled="!selectedCalibration || !selectedCalibration.isNew"
                               v-model="polygon.storeData.polyName" @input="onPolyDataChanged"></b-input>
                    </b-field>
                  </div>
                  <div class="column is-4 m-0 p-0">
                    <b-field label="Coordinates" label-position="on-border">
                      <b-input placeholder="Coordinates" rounded type="text" size="is-small"
                               :disabled="!selectedCalibration || !selectedCalibration.isNew"
                               v-model="polygon.ptsString"></b-input>
                    </b-field>
                  </div>
                  <div class="column is-6 m-0 p-0 is-flex">
                    <b-button icon-left="delete" size="is-small" class="ml-auto" @mouseover="onHover(polygon.id)"
                              @mouseleave="onLeave(polygon.id)" @click="onDelete(polygon.id)"></b-button>
                  </div>
                </div>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="Dwell Polygons" icon="vector-polygon-variant">
            <div>
              <hr class="mt-3 mb-4 has-background-grey-light mr-0" style="height: 1px">
              <div class="card shadow mb-3" v-for="polygon in videoData.dwellPolygons" :key="polygon.id">
                <div class="is-flex p-3 pt-3 columns m-0">
                  <div class="column is-2 m-0 p-0">
                    <b-field label="Ped Direction" label-position="on-border" class="mr-2">
                      <b-input placeholder="Ped direction" rounded type="text" size="is-small"
                               :disabled="!selectedCalibration || !selectedCalibration.isNew"
                               v-model="polygon.storeData.pedDirection" @input="onPolyDataChanged"></b-input>
                    </b-field>
                  </div>
                  <div class="column is-4 m-0 p-0">
                    <b-field label="Coordinates" label-position="on-border">
                      <b-input placeholder="Coordinates" rounded type="text" size="is-small"
                               :disabled="!selectedCalibration || !selectedCalibration.isNew"
                               v-model="polygon.ptsString"></b-input>
                    </b-field>
                  </div>
                  <div class="column is-6 m-0 p-0 is-flex">
                    <b-button icon-left="delete" size="is-small" class="ml-auto" @mouseover="onHover(polygon.id)"
                              @mouseleave="onLeave(polygon.id)" @click="onDelete(polygon.id)"></b-button>
                  </div>
                </div>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="Speed Lines" icon="vector-line">
            <div>
              <hr class="mt-3 mb-4 has-background-grey-light mr-0" style="height: 1px">
              <div class="card shadow mb-3" v-for="line in videoData.speedLines" :key="line.id">
                <div class="is-flex p-3 pt-3 columns m-0">
                  <div class="column is-6 m-0 p-0">
                    <b-field label="Coordinates" label-position="on-border">
                      <b-input placeholder="Coordinates" rounded type="text" size="is-small"
                               :disabled="!selectedCalibration || !selectedCalibration.isNew"
                               v-model="line.ptsString"></b-input>
                    </b-field>
                  </div>
                  <div class="column is-6 m-0 p-0 is-flex">
                    <b-button icon-left="delete" size="is-small" class="ml-auto" @mouseover="onHover(line.id)"
                              :disabled="!selectedCalibration || !selectedCalibration.isNew"
                              @mouseleave="onLeave(line.id)" @click="onDelete(line.id)"></b-button>
                  </div>
                </div>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="Event lines" icon="vector-line">
            <div>
              <hr class="mt-3 mb-4 has-background-grey-light mr-0" style="height: 1px">
              <div class="card shadow mb-3" v-for="eventLine in videoData.eventLines" :key="eventLine.id">
                <div class="is-flex p-3 pt-3 columns m-0">
                  <div class="column is-6 m-0 p-0">
                    <b-field label="Coordinates" label-position="on-border">
                      <b-input placeholder="Coordinates" rounded type="text" size="is-small"
                               :disabled="!selectedCalibration || !selectedCalibration.isNew"
                               v-model="eventLine.ptsString"></b-input>
                    </b-field>
                  </div>
                  <div class="column is-6 m-0 p-0 is-flex">
                    <b-button icon-left="delete" size="is-small" class="ml-auto" @mouseover="onHover(eventLine.id)"
                              :disabled="!selectedCalibration || !selectedCalibration.isNew"
                              @mouseleave="onLeave(eventLine.id)" @click="onDelete(eventLine.id)"></b-button>
                  </div>
                </div>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="Approaches" icon="road-variant">
            <hr class="mt-3 mb-4 has-background-grey-light mr-0" style="height: 1px">
            <div class="card shadow mb-3" v-for="approach in videoData.approaches" :key="approach.id">
              <div class="is-flex p-3 pt-3 columns m-0">
                <div class="column is-3 m-0 p-0">
                  <b-field label="Direction Name" label-position="on-border" class="mr-2">
                    <b-input placeholder="ID" rounded type="text" size="is-small"
                             :disabled="!selectedCalibration || !selectedCalibration.isNew"
                             v-model="approach.key" @input="onApproachKeyChanged(approach.id, $event)"></b-input>
                  </b-field>
                </div>
                <div class="column is-3 m-0 p-0">
                  <b-field label="Approach Name" label-position="on-border" class="mr-2">
                    <b-input placeholder="Approach Name" rounded type="text" size="is-small"
                             :disabled="!selectedCalibration || !selectedCalibration.isNew"
                             v-model="approach.value"></b-input>
                  </b-field>
                </div>
                <div class="column is-6 m-0 p-0 is-flex">
                  <b-button icon-left="delete" size="is-small" class="ml-auto" @mouseover="onHover(approach.id)"
                            :disabled="!selectedCalibration || !selectedCalibration.isNew"
                            @mouseleave="onLeave(approach.id)" @click="onDelete(approach.id)"></b-button>
                </div>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="Mid line" icon="vector-line">
            <div>
              <hr class="mt-3 mb-4 has-background-grey-light mr-0" style="height: 1px">
              <div class="card shadow mb-3" v-for="midLine in videoData.midLine" :key="midLine.id">
                <div class="is-flex p-3 pt-3 columns m-0">
                  <div class="column is-6 m-0 p-0">
                    <b-field label="Coordinates" label-position="on-border">
                      <b-input placeholder="Coordinates" rounded type="text" size="is-small"
                               :disabled="!selectedCalibration || !selectedCalibration.isNew"
                               v-model="midLine.ptsString"></b-input>
                    </b-field>
                  </div>
                  <div class="column is-6 m-0 p-0 is-flex">
                    <b-button icon-left="delete" size="is-small" class="ml-auto" @mouseover="onHover(midLine.id)"
                              :disabled="!selectedCalibration || !selectedCalibration.isNew"
                              @mouseleave="onLeave(midLine.id)" @click="onDelete(midLine.id)"></b-button>
                  </div>
                </div>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="World rectangle" icon="vector-polygon-variant">
            <div>
              <hr class="mt-3 mb-4 has-background-grey-light mr-0" style="height: 1px">
              <b-notification type="is-info is-light" aria-close-label="Close notification">
                Start drawing on the video in a counter-clockwise direction.
                The first line of the polygon is always drawn along the width of the road.
                Drawing on the map also goes counter-clockwise, along the width of the road,
                and after the first line is drawn, drag the mouse in the desired direction to draw a regular rectangle
              </b-notification>
              <div class="card shadow mb-3" v-for="polygon in videoData.worldRect" :key="polygon.id">
                <div class="is-flex pl-3 pt-3 pr-3 pb-0 columns m-0">
                  <div class="column is-2 m-0 p-0" v-for="(dot, index) in polygon.storeData.polyDots"
                       :key="dot.value.toString()">
                    <div class="is-flex is-flex-direction-row">
                      <b-field label="Point Name" label-position="on-border" class="mr-1">
                        <b-input placeholder="Polygon Name" rounded type="text" size="is-small"
                                 :disabled="!selectedCalibration || !selectedCalibration.isNew"
                                 v-model="dot.key" @input="onWorldRectKeyChanged(dot.key, $event, index)"></b-input>
                      </b-field>
                      <b-tag class="mr-6" style="margin-top: 3px;">{{ dot.value }}</b-tag>
                    </div>

                  </div>
                  <div class="column m-0 p-0 is-flex">
                    <b-button icon-left="delete" size="is-small" class="ml-auto" @mouseover="onHover(polygon.id)"
                              @mouseleave="onLeave(polygon.id)" @click="onDelete(polygon.id)"></b-button>
                  </div>
                </div>
                <div class="columns m-0 pl-3 pr-3 pb-3">
                  <div class="column is-6 p-0 pr-1">
                    <b-field label="Distance AB (m)" label-position="on-border">
                      <b-input type="number" size="is-small" rounded step="0.001"
                               v-model.number="polygon.storeData.distanceAB"
                               :disabled="!selectedCalibration || !selectedCalibration.isNew"
                               @input="onPolyDataChanged" />
                    </b-field>
                  </div>
                  <div class="column is-6 p-0 pl-1">
                    <b-field label="Distance Left-Right (m)" label-position="on-border">
                      <b-input type="number" size="is-small" rounded step="0.001"
                               v-model.number="polygon.storeData.distanceLeftRight"
                               :disabled="!selectedCalibration || !selectedCalibration.isNew"
                               @input="onPolyDataChanged" />
                    </b-field>
                  </div>
                </div>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="Lanes" icon="road-variant">
            <div>
              <hr class="mt-3 mb-4 has-background-grey-light mr-0" style="height: 1px">
              <div v-if="lanesCombinations.length === 0" class="has-text-grey-light has-text-centered p-5">
                No stage or direction polygons defined. Add stage and direction polygons to configure lanes.
              </div>
              <div class="card shadow mb-3" v-for="lane in lanesCombinations" :key="lane.stage + '_' + lane.direction">
                <div class="is-flex p-3 pt-3 columns m-0">
                  <div class="column is-3 m-0 p-0">
                    <b-field label="Stage" label-position="on-border" class="mr-2">
                      <b-input :value="lane.stage" rounded type="text" size="is-small" disabled></b-input>
                    </b-field>
                  </div>
                  <div class="column is-3 m-0 p-0">
                    <b-field label="Direction" label-position="on-border" class="mr-2">
                      <b-input :value="lane.direction" rounded type="text" size="is-small" disabled></b-input>
                    </b-field>
                  </div>
                  <div class="column is-3 m-0 p-0">
                    <b-field label="Number of Lanes" label-position="on-border" class="mr-2">
                      <b-input placeholder="0" rounded type="number" size="is-small"
                               :disabled="!selectedCalibration || !selectedCalibration.isNew"
                               v-model.number="lane.numberOfLanes"
                               @input="onLanesChanged"></b-input>
                    </b-field>
                  </div>
                </div>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="Output" icon="code-json">
            <hr class="mt-3 mb-4 has-background-grey-light mr-0" style="height: 1px">
            <div class="is-flex p-3 pt-3 columns m-0">
              <div class="column is-6 m-0 p-0">
                <b-field label="Output" label-position="on-border" class="mr-2">
                  <b-input placeholder="OUTPUT" rounded type="textarea" size="is-small"
                           :disabled="!selectedCalibration || !selectedCalibration.isNew"
                           :value="getOutput()"></b-input>
                </b-field>
              </div>
              <div class="column is-6 m-0 p-0">
                <b-field label="Normalized Output" label-position="on-border" class="mr-2">
                  <b-input placeholder="NORMALIZED OUTPUT" rounded type="textarea" size="is-small"
                           :disabled="!selectedCalibration || !selectedCalibration.isNew"
                           :value="getNormalizedData()"></b-input>
                </b-field>
              </div>
            </div>
          </b-tab-item>
        </b-tabs>
      </div>
      <div v-else class="m-4 pb-6 mt-5" style="min-height: 500px;">
        <video-calibrations @onCloneCalibration="onCloneCalibration"
                            @onEditCalibration="onEditCalibration"></video-calibrations>
      </div>
    </div>
  </div>
</template>
<script>
import DrawMap from "@/modules/data-processing-module/components/draw-map/draw-map.vue";
import DrawOnVideo from "@/modules/data-processing-module/components/draw-canvas/draw-on-video.vue";
import {distance, point} from "@turf/turf";
import index, {mapActions, mapGetters} from "vuex";
import VideoCalibrations from "@/modules/data-processing-module/components/video-calibrations/video-calibrations.vue";
import ActionsBar from "@/modules/data-processing-module/components/actions-bar/actions-bar.vue";
import {formatTimeInTimeZone, getDateTime, getVideoTimeFromLocal, VideoCalibrationCategory} from "@/utils/utils";
import {nextTick} from "vue";

export default {
  name: "video-calibration",
  components: {ActionsBar, VideoCalibrations, DrawMap, DrawOnVideo},
  props: {
    projectId: {
      type: String,
      required: true,
      default: '',
    },
    dataDeviceId: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      videoSrcWidth: 0,
      videoSrcHeight: 0,
      videoLoaded: false,
      tabIndex: -1,
      videoData: {
        stagePolygons: [],
        directionPolygons: [],
        dwellPolygons: [],
        speedLines: [],
        eventLines: [],
        midLine: [],
        approaches: [],
        measurements: [],
        geoLines: null,
        crossingDistanceGeoLines: null,
        worldRectGeoLines: null,
        speedDistances: [],
        numberOfLanes: []
      },
      storeData: null,
      isVideoPlaying: false
    }
  },
  async mounted() {
    if (this.allProjects.length === 0) {
      this.isLoading = true
      await this.fetchAllProjects()
      let index = this.allProjects.findIndex(prj => prj._id === this.projectId)
      if (index !== -1) {
        await this.setSelectedProcessingProject(this.allProjects[index])

        //Find device data
        let deviceIndex = this.selectedProject.devices.findIndex(device => device._id === this.dataDeviceId)
        if (deviceIndex !== -1) {
          await this.setSelectedVideoCalibrations(this.selectedProject.devices[deviceIndex].videoCalibrations)
          await this.setSelectedProcessingDevice(this.selectedProject.devices[deviceIndex])
        }
      }


      this.isLoading = false
    }

    console.log('Selected device: ', this.selectedDevice)

    this.scrollToTop()
    this.video = document.getElementById("vid");
    this.timeout = null
    const observer = new ResizeObserver(entries => {
      entries.forEach(entry => {
        const cr = entry.contentRect;
        console.log(`Element size: ${cr.width}px x ${cr.height}px`);
        let roundedWidth = Math.round(cr.width)
        let roundedHeight = Math.round(cr.height)

        if (this.timeout) {
          clearTimeout(this.timeout)
        }
        this.timeout = setTimeout(() => {
          if (this.$refs.videoDraw) {
            this.$refs.videoDraw.setSize(roundedWidth, roundedHeight)
            this.$refs.mapDraw.setMapHeight(roundedHeight)
            this.videoSrcWidth = this.video.videoWidth
            this.videoSrcHeight = this.video.videoHeight
            console.log('Width&Height of video', this.videoSrcWidth, this.videoSrcHeight)
            this.$refs.videoDraw.setOriginalVideoDimensions(this.videoSrcWidth, this.videoSrcHeight)
            if (this.videoSrcWidth && this.videoSrcHeight) {
              this.isLoading = false
            }
          }
        }, 300);

      })
    })
    observer.observe(this.$refs.videoRef)

    this.convertAndSetData()
    this.parseData(this.storeData)
    this.$refs.mapDraw.setFeature(this.storeData ? this.storeData.geoLines : null)
    this.$refs.mapDraw.setCrossingDistanceFeature(this.storeData ? this.storeData.crossingDistanceGeoLines : null)
    this.$refs.mapDraw.setWorldRectFeature(this.storeData ? this.storeData.worldRectGeoLines : null)
    this.isLoading = true
  },
  beforeDestroy() {

  },
  methods: {
    ...mapActions({
      selectCalibration: 'dataProcessingModule/selectCalibration',
      saveCalibration: 'dataProcessingModule/saveCalibration',
      editCalibration: 'dataProcessingModule/editCalibration',
      fetchAllProjects: 'projectsModule/getAllProjects',
      setSelectedProcessingProject: 'dataProcessingModule/setSelectedProcessingProject',
      setSelectedVideoCalibrations: 'dataProcessingModule/setSelectedVideoCalibrations',
      setSelectedProcessingDevice: 'dataProcessingModule/setSelectedProcessingDevice',
      getVideoUrl: 'dataProcessingModule/getVideoUrl',
    }),
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    async onVideoChanged(videoMetaData) {
      this.videoLoaded = false
      this.isLoading = true
      let response = await this.getVideoUrl(videoMetaData._id)
      if (response.errorMessage) {
        this.showToast(response.errorMessage, 'is-danger')
      } else {
        //this.showToast('Video Calibration successfully created', 'is-success')
        let selected = JSON.parse(JSON.stringify(this.selectedCalibration))
        selected.videoMetaDataId = response.videoMetaDataId
        selected.localCaptureStart = response.localCaptureStart
        selected.localCaptureEnd = response.localCaptureEnd
        selected.videoUrl = response.videoUrl
        await this.selectCalibration(selected)
        this.$refs.videoRef.src = selected.videoUrl
      }
    },
    onPlayPauseVideo() {
      if (this.isVideoPlaying) {
        this.isVideoPlaying = false
        this.$refs.videoRef.pause()
      } else {
        this.isVideoPlaying = true
        this.$refs.videoRef.play()
      }
    },
    onCloseCalibration() {
      this.$refs.mapDraw.onClose()
    },
    getVideoStart() {
      if (this.selectedCalibration) {
        if (this.selectedCalibration.localCaptureStart) {
          return getDateTime(this.selectedCalibration.localCaptureStart, this.selectedDevice.site.timezone)
        }
        return '--:--'
      } else if (this.selectedDevice) {
        if (this.selectedDevice.localCaptureStart) {
          return getDateTime(this.selectedDevice.localCaptureStart, this.selectedDevice.site.timezone)
        }
      }

      return '--:--'
    },
    getVideoEnd() {
      if (this.selectedCalibration) {
        if (this.selectedCalibration.localCaptureEnd) {
          return getDateTime(this.selectedCalibration.localCaptureEnd, this.selectedDevice.site.timezone)
        }

        return '--:--'
      } else if (this.selectedDevice) {
        if (this.selectedDevice.localCaptureEnd) {
          return getDateTime(this.selectedDevice.localCaptureEnd, this.selectedDevice.site.timezone)
        }
      }

      return '--:--'
    },
    convertAndSetData() {
      if (this.selectedCalibration && this.selectedCalibration.pixelCalibration) {
        let data = JSON.parse(JSON.stringify(this.selectedCalibration.pixelCalibration))
        if (data && data.approaches) {
          let approachesList = []
          Object.keys(data.approaches).forEach(key => {
            let item = {}
            item[key] = data.approaches[key]
            approachesList.push(item)
          })
          data.approaches = approachesList
        }

        this.storeData = JSON.parse(JSON.stringify(data))
        console.log('Convert and set data: ', this.storeData)
      } else {
        this.storeData = null
      }
    },
    getOutput() {
      console.log('Get output store: ', this.storeData)
      console.log('Get output video: ', this.videoData)
      let store = JSON.parse(JSON.stringify(this.storeData))
      if (store && store.approaches) {
        let dict = {};
        store.approaches.forEach(approach => {
          let key = Object.keys(approach)[0]
          dict[key] = approach[key]
        })
        store.approaches = dict
      }
      return JSON.stringify(store)
    },
    getNormalizedData() {
      let store = JSON.parse(JSON.stringify(this.storeData))

      if (store && store.approaches) {
        let dict = {};
        store.approaches.forEach(approach => {
          let key = Object.keys(approach)[0]
          dict[key] = approach[key]
        })
        store.approaches = dict
      }

      return JSON.stringify(this.normalize(store))
    },
    normalize(storeData) {
      if (this.videoSrcWidth && this.videoSrcHeight && storeData) {
        let normalizedData = JSON.parse(JSON.stringify(storeData))
        if (normalizedData.stagePolygons && normalizedData.stagePolygons.length > 0) {
          normalizedData.stagePolygons.forEach(polygon => {
            if (polygon.pts) {
              polygon.pts.forEach(pt => {
                pt[0] = parseFloat((pt[0] / this.videoSrcWidth).toFixed(3))
                pt[1] = parseFloat((pt[1] / this.videoSrcHeight).toFixed(3))
              })
            }

            console.log('POLY: ', polygon)

            if (polygon.crossingDistance) {
              polygon.crossingDistance = parseFloat(polygon.crossingDistance.toFixed(3))
            }
          })
        }

        if (normalizedData.worldRect && normalizedData.worldRect.length > 0) {

          let polygon = normalizedData.worldRect[0]

/*          if (polygon.pts) {
            polygon.pts.forEach(pt => {
              pt[0] = parseFloat((pt[0] / this.videoSrcWidth).toFixed(3))
              pt[1] = parseFloat((pt[1] / this.videoSrcHeight).toFixed(3))
            })
          }*/

          if (polygon.polyDots) {
            polygon.polyDots.forEach(dot => {
              polygon[dot.key] = [ parseFloat((dot.value[0] / this.videoSrcWidth).toFixed(3)), parseFloat((dot.value[1]  / this.videoSrcHeight).toFixed(3))]
            })
          }

          console.log('POLY WORLD RECT: ', polygon)

          if (polygon.distanceAB) {
            polygon.distanceAB = parseFloat(polygon.distanceAB.toFixed(3))
          }

          if (polygon.distanceLeftRight) {
            polygon.distanceLeftRight = parseFloat(polygon.distanceLeftRight.toFixed(3))
          }

          delete polygon.pts
          delete polygon.polyDots
          normalizedData.worldRectangle = JSON.parse(JSON.stringify(polygon))
          delete normalizedData.worldRect

        }

        if (normalizedData.directionPolygons && normalizedData.directionPolygons.length > 0) {
          normalizedData.directionPolygons.forEach(polygon => {
            if (polygon.pts) {
              polygon.pts.forEach(pt => {
                pt[0] = parseFloat((pt[0] / this.videoSrcWidth).toFixed(3))
                pt[1] = parseFloat((pt[1] / this.videoSrcHeight).toFixed(3))
              })
            }
          })
        }

        if (normalizedData.dwellPolygons && normalizedData.dwellPolygons.length > 0) {
          normalizedData.dwellPolygons.forEach(polygon => {
            if (polygon.pts) {
              polygon.pts.forEach(pt => {
                pt[0] = parseFloat((pt[0] / this.videoSrcWidth).toFixed(3))
                pt[1] = parseFloat((pt[1] / this.videoSrcHeight).toFixed(3))
              })
            }
          })
        }

        if (normalizedData.speedLines && normalizedData.speedLines.length > 0) {
          normalizedData.speedLines.forEach(line => {
            if (line.length === 2) {
              line[0][0] = parseFloat((line[0][0] / this.videoSrcWidth).toFixed(3))
              line[0][1] = parseFloat((line[0][1] / this.videoSrcHeight).toFixed(3))
              line[1][0] = parseFloat((line[1][0] / this.videoSrcWidth).toFixed(3))
              line[1][1] = parseFloat((line[1][1] / this.videoSrcHeight).toFixed(3))
            }
          })
        }

        if (normalizedData.eventLines && normalizedData.eventLines.length > 0) {
          normalizedData.eventLines.forEach(line => {
            if (line.length === 2) {
              line[0][0] = parseFloat((line[0][0] / this.videoSrcWidth).toFixed(3))
              line[0][1] = parseFloat((line[0][1] / this.videoSrcHeight).toFixed(3))
              line[1][0] = parseFloat((line[1][0] / this.videoSrcWidth).toFixed(3))
              line[1][1] = parseFloat((line[1][1] / this.videoSrcHeight).toFixed(3))
            }
          })
        }

        if (normalizedData.midLine && normalizedData.midLine.length > 0) {
          normalizedData.midLine.forEach(line => {
            line.forEach(pt => {
              pt[0] = parseFloat((pt[0] / this.videoSrcWidth).toFixed(3))
              pt[1] = parseFloat((pt[1] / this.videoSrcHeight).toFixed(3))
            })
          })

          normalizedData.midLine = JSON.parse(JSON.stringify(normalizedData.midLine[0]))
        }

        if (normalizedData.approaches) {
          Object.keys(normalizedData.approaches).forEach(key => {
            normalizedData.approaches[key][0] = parseFloat((normalizedData.approaches[key][0] / this.videoSrcWidth).toFixed(3))
            normalizedData.approaches[key][1] = parseFloat((normalizedData.approaches[key][1] / this.videoSrcHeight).toFixed(3))
          })
        }

        delete normalizedData.geoLines
        delete normalizedData.crossingDistanceGeoLines
        delete normalizedData.worldRectGeoLines
        delete normalizedData.isNew

        return normalizedData
      }
      return null
    },
    async saveData() {
      console.log('On save data')
      if (this.videoSrcWidth && this.videoSrcHeight) {

        this.setStoreData()
        let saveData = JSON.parse(JSON.stringify(this.storeData))

        let dict = {};
        saveData.approaches.forEach(approach => {
          let key = Object.keys(approach)[0]
          dict[key] = approach[key]
        })
        saveData.approaches = dict
        let normalized = this.normalize(saveData)
        let payload = JSON.parse(JSON.stringify(this.selectedCalibration))

        payload.pixelCalibration = saveData
        payload.calibration = normalized


        delete payload.validFromPicker
        delete payload.validToPicker
        delete payload.isNew
        delete payload.localCaptureStart
        delete payload.localCaptureEnd
        delete payload.availableFiles
        delete payload.videoUrl

        if (payload.calibration === null) {
          this.showToast('Normalized calibration not created. ', 'is-danger')
        }

        this.isLoading = true

        if (payload.isEdit) {
          console.log('Is edit: ', true)
          delete payload.isEdit
          let response = await this.editCalibration(payload)
          if (response.errorMessage) {
            this.showToast(response.errorMessage, 'is-danger')
          } else {
            this.showToast('Video Calibration successfully updated', 'is-success')
            await this.selectCalibration(null)
          }
        } else {
          let response = await this.saveCalibration(payload)
          if (response.errorMessage) {
            this.showToast(response.errorMessage, 'is-danger')
          } else {
            this.showToast('Video Calibration successfully created', 'is-success')
            await this.selectCalibration(null)
          }
        }


        this.isLoading = false
        console.log('SAve Payload: ', payload)
      } else {
        this.showToast('Can not create calibration. Video is not loaded correctly.', 'is-danger')
      }
    },
    onLinesDrawn(features) {


      if (this.tabIndex === 3) {
        this.videoData.geoLines = features

        let allDrawings = this.videoData.geoLines

        let linePairs = []
        let pickedDistances = []
        if (allDrawings && allDrawings.features && allDrawings.features.length > 1) {
          let features = allDrawings.features
          for (let i = 0; i < features.length - 1; i++) {
            linePairs.push({first: features[i].geometry.coordinates, second: features[i + 1].geometry.coordinates})
          }
        }

        if (linePairs.length > 0) {
          let options = {units: "kilometers"};
          linePairs.forEach(linePair => {
            let distOne = distance(point(linePair.first[0]), point(linePair.second[0]), options);
            let distTwo = distance(point(linePair.first[0]), point(linePair.second[1]), options);

            let pick = distOne < distTwo ? distOne : distTwo
            pick = parseFloat((pick * 1000.0).toFixed(3))

            pickedDistances.push(pick)
            console.log('Distance: ', `First dist ${distOne} km, Second dist ${distTwo} PICK: ${pick}m`)
          })
        }

        this.videoData.speedDistances = pickedDistances
      } else if (this.tabIndex === 0) {
        this.videoData.crossingDistanceGeoLines = features

        let allDrawings = this.videoData.crossingDistanceGeoLines
        console.log('All Drivings Crossing', allDrawings)

        this.videoData.stagePolygons.forEach(poly => {
          poly.storeData.crossingDistance = null
        })

        if (allDrawings && allDrawings.features && allDrawings.features.length > 0) {
          allDrawings.features.forEach(feature => {
            let options = {units: "kilometers"};
            let coordinates = feature.geometry.coordinates
            let dist = distance(point(coordinates[0]), point(coordinates[1]), options);
            dist = parseFloat((dist * 1000.0).toFixed(3))

            let polyIndex = this.videoData.stagePolygons.findIndex(polygon => polygon.id === feature.id)
            if (polyIndex !== -1) {
              this.videoData.stagePolygons[polyIndex].storeData.crossingDistance = dist
            }
          })
        }
      } else if (this.tabIndex === 7) {

        console.log('On lines drawn: ', features)

        this.videoData.worldRectGeoLines = features

        let allDrawings = this.videoData.worldRectGeoLines
        console.log('All Drivings World', allDrawings)

        this.videoData.worldRect.forEach(poly => {
          poly.storeData.distanceAB = null
          poly.storeData.distanceLeftRight = null
        })

        if (allDrawings && allDrawings.features && allDrawings.features.length > 0) {
          allDrawings.features.forEach(feature => {
            console.log('On World Feature: ', feature)
            console.log('On World Feature World Rect: ', this.videoData.worldRect)


            let options = {units: "kilometers"};
            let coordinates = feature.geometry.coordinates[0]
            let distAB = distance(point(coordinates[1]), point(coordinates[2]), options);
            distAB = parseFloat((distAB * 1000.0).toFixed(3))

            let distLeftRight = distance(point(coordinates[0]), point(coordinates[1]), options);
            distLeftRight = parseFloat((distLeftRight * 1000.0).toFixed(3))

            let worldRectIndex = this.videoData.worldRect.findIndex(polygon => polygon.id === feature.id)
            console.log('On World Feature World Rect index: ', worldRectIndex)
            if (worldRectIndex !== -1) {
              this.videoData.worldRect[worldRectIndex].storeData.distanceAB = distAB
              this.videoData.worldRect[worldRectIndex].storeData.distanceLeftRight = distLeftRight
              console.log('On World Feature set AB: ', distAB)
              console.log('On World Feature set  Left Right: ', distLeftRight)
            }
          })
        }
      }

      this.refreshData()
    },
    setStoreData() {
      this.storeData = {
        stagePolygons: this.videoData.stagePolygons.map(poly => poly.storeData),
        worldRect: this.videoData.worldRect.map(poly => poly.storeData),
        directionPolygons: this.videoData.directionPolygons.map(poly => poly.storeData),
        dwellPolygons: this.videoData.dwellPolygons.map(poly => poly.storeData),
        speedLines: this.videoData.speedLines.map(line => line.storeData),
        eventLines: this.videoData.eventLines.map(eLine => eLine.storeData),
        midLine: this.videoData.midLine.map(line => line.storeData),
        approaches: this.videoData.approaches.map(approach => approach.storeData),
        speedDistances: this.videoData.speedDistances,
        numberOfLanes: this.videoData.numberOfLanes,
        geoLines: this.videoData.geoLines,
        crossingDistanceGeoLines: this.videoData.crossingDistanceGeoLines,
        worldRectGeoLines: this.videoData.worldRectGeoLines
      }

      console.log('Set store data: ', this.storeData)
      console.log('Set store data video: ', this.videoData)
    },
    refreshData() {
      if (this.videoData && this.videoSrcWidth !== 0 && this.videoSrcHeight !== 0 && this.selectedCalibration) {
        setTimeout(() => {
          this.setStoreData()
          console.log('Refresh data: ', this.storeData)
          this.parseData(this.storeData)
        }, 500)
      }
    },
    onColorChanged() {
      this.refreshData()
    },
    onHover(imageId) {
      this.$refs.videoDraw.onDeleteHover(imageId)
    },
    onLeave(imageId) {
      this.$refs.videoDraw.onDeleteLeave(imageId)
    },
    onDelete(imageId) {
      if (this.selectCalibration && this.selectedCalibration.isNew) {
        this.$refs.videoDraw.onDelete(imageId)
      }
    },
    async onWorldRectKeyChanged(key, event, index) {
      console.log('World key changed', key, event, this.videoData.worldRect[0].drawData)

      if (this.videoData.worldRect && this.videoData.worldRect.length > 0) {
        this.videoData.worldRect[0].drawData.texts[index] = key

        this.setStoreData()

        let allDrawData = [
          ...this.videoData.stagePolygons.map(poly => poly.drawData),
          ...this.videoData.worldRect.map(poly => poly.drawData),
          ...this.videoData.directionPolygons.map(poly => poly.drawData),
          ...this.videoData.dwellPolygons.map(poly => poly.drawData),
          ...this.videoData.speedLines.map(line => line.drawData),
          ...this.videoData.eventLines.map(eLine => eLine.drawData),
          ...this.videoData.midLine.map(eLine => eLine.drawData),
          ...this.videoData.approaches.map(app => app.drawData),
          ...this.videoData.measurements
        ]

        console.log('All DATA: ', allDrawData)
        this.$refs.videoDraw.setInputData(allDrawData)

      }


    },
    onApproachKeyChanged(imageId, event) {
      console.log('Approach key changed', imageId, event)

      let index = this.videoData.approaches.findIndex(app => app.id === imageId)
      if (index !== -1) {
        let oldData = JSON.parse(JSON.stringify(this.videoData.approaches[index].storeData))
        let obj = {}
        obj[event] = Object.values(oldData)[0]
        this.videoData.approaches[index].storeData = obj
        this.videoData.approaches[index].key = event
        this.videoData.approaches[index].value = JSON.stringify(Object.values(oldData)[0])
        this.videoData.approaches[index].drawData.text = event
      }

      let allDrawData = [
        ...this.videoData.stagePolygons.map(poly => poly.drawData),
        ...this.videoData.worldRect.map(poly => poly.drawData),
        ...this.videoData.directionPolygons.map(poly => poly.drawData),
        ...this.videoData.dwellPolygons.map(poly => poly.drawData),
        ...this.videoData.speedLines.map(line => line.drawData),
        ...this.videoData.eventLines.map(eLine => eLine.drawData),
        ...this.videoData.midLine.map(eLine => eLine.drawData),
        ...this.videoData.approaches.map(app => app.drawData),
        ...this.videoData.measurements
      ]

      this.setStoreData()

      console.log('All DATA: ', allDrawData)

      this.$refs.videoDraw.setInputData(allDrawData)
    },
    onPolyDataChanged() {
      this.$nextTick(() => {
        this.setStoreData()
      })
    },
    parseData(storeData) {
      console.log('Video json', storeData)

      let currentWidth = this.$refs.videoDraw.getSize().width
      let currentHeight = this.$refs.videoDraw.getSize().height

      let diffX = currentWidth / this.videoSrcWidth
      let diffY = currentHeight / this.videoSrcHeight

      let settings = this.$refs.videoDraw.getSettings()

      this.videoData = {
        stagePolygons: [],
        worldRect: [],
        directionPolygons: [],
        dwellPolygons: [],
        speedLines: [],
        eventLines: [],
        midLine: [],
        approaches: [],
        measurements: [],
        geoLines: storeData ? storeData.geoLines : null,
        crossingDistanceGeoLines: storeData ? storeData.crossingDistanceGeoLines : null,
        worldRectGeoLines: storeData ? storeData.worldRectGeoLines : null,
        speedDistances: storeData ? storeData.speedDistances : null,
        numberOfLanes: storeData && storeData.numberOfLanes ? storeData.numberOfLanes : [],
      }

      if (storeData === null) {
        this.$refs.videoDraw.setInputData([])
        return
      }

      if (storeData) {
        if (storeData.stagePolygons) {
          storeData.stagePolygons.forEach((polygon, index) => {
            let coordinates = []
            polygon.pts.forEach(pt => {
              console.log('pt:', pt[1])
              let point = {
                x: Math.round(pt[0] * diffX),
                y: Math.round(pt[1] * diffY)
              }
              coordinates.push(point)
            })
            let drawData = {
              id: `${VideoCalibrationCategory.STAGE_POLYGON}_${index}`,
              type: 'polygon',
              from: coordinates[0],
              coordinates: coordinates.slice(1),
              text: null,
              textPosition: null,
              renderedDimensions: {width: currentWidth, height: currentHeight},
              category: VideoCalibrationCategory.STAGE_POLYGON
            }

            let merged = Object.assign(drawData, settings)

            this.videoData.stagePolygons.push({
              id: merged.id,
              storeData: {
                polyName: polygon.polyName,
                crossingDistance: polygon.crossingDistance,
                pts: polygon.pts,
              },
              ptsString: JSON.stringify(polygon.pts),
              drawData: merged,
              originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
            })
          })
        }
        if (storeData.worldRect) {
          storeData.worldRect.forEach((polygon, index) => {
            let coordinates = []
            polygon.pts.forEach(pt => {
              console.log('pt:', pt[1])
              let point = {
                x: Math.round(pt[0] * diffX),
                y: Math.round(pt[1] * diffY)
              }
              coordinates.push(point)
            })

            let polyDots = polygon.polyDots ? polygon.polyDots : [
              {key: 'ALeft', value: polygon.pts[0]},
              {key: 'ARight', value: polygon.pts[1]},
              {key: 'BRight', value: polygon.pts[2]},
              {key: 'BLeft', value: polygon.pts[3]}
            ]


            let textPos = {
              x: Math.round(polyDots[0].value[0] * diffX),
              y: Math.round(polyDots[0].value[1] * diffY)
            }

            let textPos1 = {
              x: Math.round(polyDots[1].value[0] * diffX),
              y: Math.round(polyDots[1].value[1] * diffY)
            }

            let textPos2 = {
              x: Math.round(polyDots[2].value[0] * diffX),
              y: Math.round(polyDots[2].value[1] * diffY)
            }

            let textPos3 = {
              x: Math.round(polyDots[3].value[0] * diffX),
              y: Math.round(polyDots[3].value[1] * diffY)
            }

            let drawData = {
              id: `${VideoCalibrationCategory.WORLD_RECT}_${index}`,
              type: 'polygon',
              from: coordinates[0],
              coordinates: coordinates.slice(1),
              text: null,
              textPosition: null,
              texts: [polyDots[0].key, polyDots[1].key, polyDots[2].key, polyDots[3].key],
              textPositions: [textPos, textPos1, textPos2, textPos3],
              renderedDimensions: {width: currentWidth, height: currentHeight},
              category: VideoCalibrationCategory.WORLD_RECT
            }

            let merged = Object.assign(drawData, settings)


            this.videoData.worldRect.push({
              id: merged.id,
              storeData: {
                polyDots: polyDots,
                distanceAB: polygon.distanceAB,
                distanceLeftRight: polygon.distanceLeftRight,
                pts: polygon.pts,
              },
              ptsString: JSON.stringify(polygon.pts),
              drawData: merged,
              originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
            })
          })
        }
        if (storeData.directionPolygons) {
          storeData.directionPolygons.forEach((polygon, index) => {
            let coordinates = []
            polygon.pts.forEach(pt => {
              let point = {
                x: Math.round(pt[0] * diffX),
                y: Math.round(pt[1] * diffY)
              }
              coordinates.push(point)
            })
            let drawData = {
              id: `${VideoCalibrationCategory.DIRECTION_POLYGON}_${index}`,
              type: 'polygon',
              from: coordinates[0],
              coordinates: coordinates.slice(1),
              text: null,
              textPosition: null,
              renderedDimensions: {width: currentWidth, height: currentHeight},
              category: VideoCalibrationCategory.DIRECTION_POLYGON
            }

            let merged = Object.assign(drawData, settings)

            this.videoData.directionPolygons.push({
              id: merged.id,
              storeData: {
                polyName: polygon.polyName,
                pts: polygon.pts,
              },
              ptsString: JSON.stringify(polygon.pts),
              drawData: merged,
              originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
            })
          })
        }
        if (storeData.dwellPolygons) {
          storeData.dwellPolygons.forEach((polygon, index) => {
            let coordinates = []
            polygon.pts.forEach(pt => {
              let point = {
                x: Math.round(pt[0] * diffX),
                y: Math.round(pt[1] * diffY)
              }
              coordinates.push(point)
            })
            let drawData = {
              id: `${VideoCalibrationCategory.DWELL_POLYGON}_${index}`,
              type: 'polygon',
              from: coordinates[0],
              coordinates: coordinates.slice(1),
              text: null,
              textPosition: null,
              renderedDimensions: {width: currentWidth, height: currentHeight},
              category: VideoCalibrationCategory.DWELL_POLYGON
            }

            let merged = Object.assign(drawData, settings)

            this.videoData.dwellPolygons.push({
              id: merged.id,
              storeData: {
                pedDirection: polygon.pedDirection,
                pts: polygon.pts,
              },
              ptsString: JSON.stringify(polygon.pts),
              drawData: merged,
              originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
            })
          })
        }
        if (storeData.speedLines) {
          storeData.speedLines.forEach((line, index) => {
            let coordinates = []
            line.forEach(pt => {
              let point = {
                x: Math.round(pt[0] * diffX),
                y: Math.round(pt[1] * diffY)
              }
              coordinates.push(point)
            })
            let drawData = {
              id: `${VideoCalibrationCategory.SPEED_LINE}_${index}`,
              type: 'line',
              from: coordinates[0],
              coordinates: coordinates.slice(1),
              text: null,
              textPosition: null,
              renderedDimensions: {width: currentWidth, height: currentHeight},
              category: VideoCalibrationCategory.SPEED_LINE
            }

            let merged = Object.assign(drawData, settings)

            this.videoData.speedLines.push({
              id: merged.id,
              storeData: line,
              ptsString: JSON.stringify(line),
              drawData: merged,
              originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
            })
          })
        }
        if (storeData.eventLines) {
          console.log('Store Data Event lines: ', storeData.eventLines)
          storeData.eventLines.forEach((eventLine, index) => {
            let coordinates = []
            eventLine.forEach(pt => {
              console.log('pt:', pt[1])
              let point = {
                x: Math.round(pt[0] * diffX),
                y: Math.round(pt[1] * diffY)
              }
              coordinates.push(point)
            })
            let drawData = {
              id: `${VideoCalibrationCategory.EVENT_LINE}_${index}`,
              type: 'line',
              from: coordinates[0],
              coordinates: coordinates.slice(1),
              text: null,
              textPosition: null,
              renderedDimensions: {width: currentWidth, height: currentHeight},
              category: VideoCalibrationCategory.EVENT_LINE
            }

            let merged = Object.assign(drawData, settings)

            this.videoData.eventLines.push({
              id: merged.id,
              storeData: eventLine,
              ptsString: JSON.stringify(eventLine),
              drawData: merged,
              originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
            })
          })
        }
        if (storeData.midLine) {
          console.log('Store Data Mid Line: ', storeData.midLine)
          storeData.midLine.forEach((midLine, index) => {
            let coordinates = []
            midLine.forEach(pt => {
              console.log('pt:', pt[1])
              let point = {
                x: Math.round(pt[0] * diffX),
                y: Math.round(pt[1] * diffY)
              }
              coordinates.push(point)
            })
            let drawData = {
              id: `${VideoCalibrationCategory.MID_LINE}_${index}`,
              type: 'polygon',
              from: coordinates[0],
              coordinates: coordinates.slice(1),
              text: null,
              textPosition: null,
              renderedDimensions: {width: currentWidth, height: currentHeight},
              category: VideoCalibrationCategory.MID_LINE
            }

            let merged = Object.assign(drawData, settings)

            this.videoData.midLine = []

            this.videoData.midLine.push({
              id: merged.id,
              storeData: midLine,
              ptsString: JSON.stringify(midLine),
              drawData: merged,
              originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
            })
          })
        }
        if (storeData.approaches) {
          console.log('Parse approaches', storeData.approaches)
          storeData.approaches.forEach((approach, index) => {

            let value = Object.values(approach)[0]
            let key = Object.keys(approach)[0]

            let point = {
              x: Math.round(value[0] * diffX),
              y: Math.round(value[1] * diffY)
            }
            let drawData = {
              id: `${VideoCalibrationCategory.APPROACH}_${index}`,
              type: 'dot',
              from: point,
              coordinates: [],
              text: key,
              textPosition: point,
              renderedDimensions: {width: currentWidth, height: currentHeight},
              category: VideoCalibrationCategory.APPROACH
            }

            let merged = Object.assign(drawData, settings)

            this.videoData.approaches.push({
              id: merged.id,
              storeData: approach,
              key: key,
              value: JSON.stringify(value),
              drawData: merged,
              originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
            })
          })
        }
      }

      this.setMeasurements()

      let allDrawData = [
        ...this.videoData.stagePolygons.map(poly => poly.drawData),
        ...this.videoData.worldRect.map(poly => poly.drawData),
        ...this.videoData.directionPolygons.map(poly => poly.drawData),
        ...this.videoData.dwellPolygons.map(poly => poly.drawData),
        ...this.videoData.speedLines.map(line => line.drawData),
        ...this.videoData.eventLines.map(eLine => eLine.drawData),
        ...this.videoData.midLine.map(eLine => eLine.drawData),
        ...this.videoData.approaches.map(app => app.drawData),
        ...this.videoData.measurements
      ]

      console.log('All DATA: ', allDrawData)
      this.$refs.videoDraw.setInputData(allDrawData)
    },
    setMeasurements() {

      let currentWidth = this.$refs.videoDraw.getSize().width
      let currentHeight = this.$refs.videoDraw.getSize().height

      let settings = this.$refs.videoDraw.getSettings()

      //add line measurements
      this.videoData.measurements = []
      let lines = this.videoData.speedLines.map(line => line.drawData)

      console.log('Set measurements lies:', lines)


      for (let i = 0; i < lines.length - 1; i++) {

        let first = lines[i].from
        let second = lines[i + 1].from

        let middleX = (first.x + second.x) / 2
        let middleY = (first.y + second.y) / 2
        let measureLine = {
          id: `measure_${i}`,
          type: 'line',
          from: first,
          coordinates: [second],
          text: this.storeData.speedDistances && this.storeData.speedDistances.length > i ? this.storeData.speedDistances[i] + ' m' : 'NOT MEASURED',
          textPosition: {x: middleX, y: middleY},
          renderedDimensions: {width: currentWidth, height: currentHeight},
          category: 'measurement_line'
        };

        let merged = Object.assign(measureLine, settings)
        merged.color = '#ffdb00'
        merged.width = 3
        this.videoData.measurements.push(merged)
      }

      console.log('Measurement lines:', this.videoData.measurements)
    },
    onDeleteImage(imageId) {
      console.log('On delete image', imageId)
      let polyIndex = this.videoData.stagePolygons.findIndex(poly => poly.id === imageId)
      if (polyIndex !== -1) {
        this.videoData.stagePolygons.splice(polyIndex, 1)
        this.$refs.mapDraw.deleteFeature(polyIndex)
      }

      let worldRectIndex = this.videoData.worldRect.findIndex(poly => poly.id === imageId)
      if (worldRectIndex !== -1) {
        this.videoData.worldRect.splice(polyIndex, 1)
        this.$refs.mapDraw.deleteFeature(polyIndex)
      }

      let dirIndex = this.videoData.directionPolygons.findIndex(poly => poly.id === imageId)
      if (dirIndex !== -1) {
        this.videoData.directionPolygons.splice(dirIndex, 1)
      }

      let dwellIndex = this.videoData.dwellPolygons.findIndex(poly => poly.id === imageId)
      if (dwellIndex !== -1) {
        this.videoData.dwellPolygons.splice(dwellIndex, 1)
      }

      let speedLineIndex = this.videoData.speedLines.findIndex(line => line.id === imageId)
      if (speedLineIndex !== -1) {
        this.videoData.speedLines.splice(speedLineIndex, 1)
        this.$refs.mapDraw.deleteFeature(speedLineIndex)
        this.setMeasurements()

      }
      let eLineIndex = this.videoData.eventLines.findIndex(l => l.id === imageId)
      if (eLineIndex !== -1) {
        this.videoData.eventLines.splice(eLineIndex, 1)
      }
      let midLineIndex = this.videoData.midLine.findIndex(l => l.id === imageId)
      if (midLineIndex !== -1) {
        this.videoData.midLine.splice(midLineIndex, 1)
      }
      let aIndex = this.videoData.approaches.findIndex(a => a.id === imageId)
      if (aIndex !== -1) {
        this.videoData.approaches.splice(aIndex, 1)
      }

      this.refreshData()


    },
    onDrawFinished(images) {
      console.log('On draw finished', images)

      let diffX = this.videoSrcWidth / this.$refs.videoDraw.getSize().width
      let diffY = this.videoSrcHeight / this.$refs.videoDraw.getSize().height
      //check is deleted


      images.forEach(image => {

        if (image.category === VideoCalibrationCategory.STAGE_POLYGON) {
          let points = []
          points.push(image.from)
          points.push(...image.coordinates)
          let pts = points.map(point => [Math.round(point.x * diffX), Math.round(point.y * diffY)])
          let index = this.videoData.stagePolygons.findIndex(poly => poly.id === image.id)
          if (index !== -1) {
            this.videoData.stagePolygons[index].drawData = image
            this.videoData.stagePolygons[index].pts = pts
          } else {

            let crossingDistance = null

            if (this.videoData.crossingDistanceGeoLines && this.videoData.crossingDistanceGeoLines.features
                && this.videoData.crossingDistanceGeoLines.features.length > 0) {

              let featureIndex = this.videoData.crossingDistanceGeoLines.features.findIndex(feature => feature.id === image.id)
              if (featureIndex !== -1) {
                let options = {units: "kilometers"};
                let coordinates = this.videoData.crossingDistanceGeoLines.features[featureIndex].geometry.coordinates
                let dist = distance(point(coordinates[0]), point(coordinates[1]), options);
                crossingDistance = (dist * 1000.0).toFixed(3)
              }
            }

            this.videoData.stagePolygons.push(
                {
                  id: image.id,
                  storeData: {
                    polyName: null,
                    crossingDistance: crossingDistance,
                    pts: pts,
                  },
                  ptsString: JSON.stringify(pts),
                  drawData: image,
                  originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
                }
            )
          }
        } else if (image.category === VideoCalibrationCategory.WORLD_RECT) {
          let points = []
          points.push(image.from)
          points.push(...image.coordinates)
          let pts = points.map(point => [Math.round(point.x * diffX), Math.round(point.y * diffY)])
          let index = this.videoData.worldRect.findIndex(poly => poly.id === image.id)
          if (index !== -1) {
            this.videoData.worldRect[index].drawData = image
            this.videoData.worldRect[index].storeData.pts = pts
            this.videoData.worldRect[index].ptsString = JSON.stringify(pts)
            if (this.videoData.worldRect[index].storeData.polyDots) {
              this.videoData.worldRect[index].storeData.polyDots.forEach((dot, di) => {
                if (pts[di]) {
                  dot.value = pts[di]
                }
              })
            }
          } else {

            let distanceAB = null
            let distanceLeftRight = null

            /*            if (this.videoData.worldRectGeoLines && this.videoData.worldRectGeoLines.features
                            && this.videoData.worldRectGeoLines.features.length > 0) {

                          let featureIndex = this.videoData.worldRectGeoLines.features.findIndex(feature => feature.id === image.id)
                          if (featureIndex !== -1) {
                            let options = {units: "kilometers"};
                            let coordinates = this.videoData.worldRectGeoLines.features[featureIndex].geometry.coordinates
                            let dist = distance(point(coordinates[0]), point(coordinates[1]), options);
                            worldDistance = (dist * 1000.0).toFixed(3)
                          }
                        }*/

            let polyDots = [
              {key: 'ALeft', value: pts[0]},
              {key: 'ARight', value: pts[1]},
              {key: 'BRight', value: pts[2]},
              {key: 'BLeft', value: pts[3]}
            ].filter((_, i) => i < pts.length)

            this.videoData.worldRect.push(
                {
                  id: image.id,
                  storeData: {
                    distanceAB: distanceAB,
                    distanceLeftRight: distanceLeftRight,
                    pts: pts,
                    polyDots: polyDots,
                  },
                  ptsString: JSON.stringify(pts),
                  drawData: image,
                  originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
                }
            )
          }
        } else if (image.category === VideoCalibrationCategory.DIRECTION_POLYGON) {
          let points = []
          points.push(image.from)
          points.push(...image.coordinates)
          let pts = points.map(point => [Math.round(point.x * diffX), Math.round(point.y * diffY)])
          let index = this.videoData.directionPolygons.findIndex(poly => poly.id === image.id)
          if (index !== -1) {
            this.videoData.directionPolygons[index].drawData = image
            this.videoData.directionPolygons[index].pts = pts
          } else {
            this.videoData.directionPolygons.push(
                {
                  id: image.id,
                  storeData: {
                    polyName: null,
                    pts: pts,
                  },
                  ptsString: JSON.stringify(pts),
                  drawData: image,
                  originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
                }
            )
          }
        } else if (image.category === VideoCalibrationCategory.DWELL_POLYGON) {
          let points = []
          points.push(image.from)
          points.push(...image.coordinates)
          let pts = points.map(point => [Math.round(point.x * diffX), Math.round(point.y * diffY)])
          let index = this.videoData.dwellPolygons.findIndex(poly => poly.id === image.id)
          if (index !== -1) {
            this.videoData.dwellPolygons[index].drawData = image
            this.videoData.dwellPolygons[index].pts = pts
          } else {
            this.videoData.dwellPolygons.push(
                {
                  id: image.id,
                  storeData: {
                    pedDirection: null,
                    pts: pts,
                  },
                  ptsString: JSON.stringify(pts),
                  drawData: image,
                  originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
                }
            )
          }
        } else if (image.category === VideoCalibrationCategory.SPEED_LINE) {
          let points = []
          points.push(image.from)
          points.push(...image.coordinates)
          let pts = points.map(point => [Math.round(point.x * diffX), Math.round(point.y * diffY)])
          let index = this.videoData.speedLines.findIndex(line => line.id === image.id)
          if (index !== -1) {
            this.videoData.speedLines[index].drawData = image
            this.videoData.speedLines[index].storeData = pts
          } else {
            this.videoData.speedLines.push(
                {
                  id: image.id,
                  storeData: pts,
                  ptsString: JSON.stringify(pts),
                  drawData: image,
                  originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
                }
            )
          }
        } else if (image.category === VideoCalibrationCategory.EVENT_LINE) {
          let points = []
          points.push(image.from)
          points.push(...image.coordinates)
          let pts = points.map(point => [Math.round(point.x * diffX), Math.round(point.y * diffY)])
          let index = this.videoData.eventLines.findIndex(line => line.id === image.id)
          if (index !== -1) {
            this.videoData.eventLines[index].drawData = image
            this.videoData.eventLines[index].storeData = pts
          } else {
            this.videoData.eventLines.push(
                {
                  id: image.id,
                  storeData: pts,
                  ptsString: JSON.stringify(pts),
                  drawData: image,
                  originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
                }
            )
          }
        } else if (image.category === VideoCalibrationCategory.MID_LINE) {
          let points = []
          points.push(image.from)
          points.push(...image.coordinates)
          let pts = points.map(point => [Math.round(point.x * diffX), Math.round(point.y * diffY)])
          let index = this.videoData.midLine.findIndex(line => line.id === image.id)
          if (index !== -1) {
            this.videoData.midLine[index].drawData = image
            this.videoData.midLine[index].storeData = pts
          } else {
            this.videoData.midLine = []
            this.videoData.midLine.push(
                {
                  id: image.id,
                  storeData: pts,
                  ptsString: JSON.stringify(pts),
                  drawData: image,
                  originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
                }
            )
          }
        } else if (image.category === VideoCalibrationCategory.APPROACH) {
          let pts = [Math.round(image.from.x * diffX), Math.round(image.from.y * diffY)]
          let obj = {}
          obj[image.text] = pts


          let index = this.videoData.approaches.findIndex(app => app.id === image.id)
          if (index !== -1) {
            this.videoData.approaches[index].drawData = image
            this.videoData.approaches[index].storeData = obj
          } else {
            this.videoData.approaches.push({
              id: image.id,
              storeData: obj,
              drawData: image,
              key: image.text,
              value: JSON.stringify(pts),
              originalDimensions: {w: this.videoSrcWidth, h: this.videoSrcHeight}
            })
          }
        }
      })

      console.log('New video data: ', this.videoData)
      this.setStoreData()
      this.parseData(this.storeData)
    },
    onTabChanged(index) {
      console.log('On tab changed: ', index)
      if (index === 0) {
        this.$refs.videoDraw.setSelectedCategory('polygon', VideoCalibrationCategory.STAGE_POLYGON)
      } else if (index === 1) {
        this.$refs.videoDraw.setSelectedCategory('polygon', VideoCalibrationCategory.DIRECTION_POLYGON)
      } else if (index === 2) {
        this.$refs.videoDraw.setSelectedCategory('polygon', VideoCalibrationCategory.DWELL_POLYGON)
      } else if (index === 3) {
        this.$refs.videoDraw.setSelectedCategory('line', VideoCalibrationCategory.SPEED_LINE)
      } else if (index === 4) {
        this.$refs.videoDraw.setSelectedCategory('line', VideoCalibrationCategory.EVENT_LINE)
      } else if (index === 5) {
        this.$refs.videoDraw.setSelectedCategory('dot', VideoCalibrationCategory.APPROACH)
      } else if (index === 6) {
        this.$refs.videoDraw.setSelectedCategory('polygon', VideoCalibrationCategory.MID_LINE)
      } else if (index === 7) {
        this.$refs.videoDraw.setSelectedCategory('polygon', VideoCalibrationCategory.WORLD_RECT)
      } else {
        this.$refs.videoDraw.setSelectedCategory('none', 'none')
      }
    },
    onLanesChanged() {
      this.$nextTick(() => {
        this.videoData.numberOfLanes = this.lanesCombinations.map(lane => ({
          stage: lane.stage,
          direction: lane.direction,
          numberOfLanes: lane.numberOfLanes
        }))
        this.setStoreData()
      })
    },
    onVideoMetaDataLoaded(e) {
      this.videoSrcWidth = e.target.videoWidth
      this.videoSrcHeight = e.target.videoHeight
      console.log('Width&Height of video', this.videoSrcWidth, this.videoSrcHeight)
      this.$refs.videoDraw.setOriginalVideoDimensions(this.videoSrcWidth, this.videoSrcHeight)
      this.isLoading = false
      this.videoLoaded = true
      //this.$refs.videoRef.play()
    },
    showToast(message, type) {
      this.$buefy.toast.open({
        message: message,
        duration: 3000,
        type: type
      })
    },
    onCloneCalibration(calibration) {
      this.$refs.actionsBar.cloneCalibration(calibration)
    },
    async onEditCalibration(calibration) {
      console.log('Calibration: ', calibration)
      let calib = JSON.parse(JSON.stringify(calibration))
      calib.isNew = true
      calib.isEdit = true
      await this.selectCalibration(calib)
    }
  },
  computed: {
    ...mapGetters({
      calibrations: 'dataProcessingModule/getSelectedVideoCalibrations',
      selectedCalibration: 'dataProcessingModule/getSelectedCalibration',
      selectedDevice: 'dataProcessingModule/getSelectedProcessingDevice',
      allProjects: 'projectsModule/getAllProjects',
      selectedProject: 'dataProcessingModule/getSelectedProcessingProject',
    }),
    lanesCombinations() {
      let stages = []
      if (this.videoData.stagePolygons && this.videoData.stagePolygons.length > 0) {
        this.videoData.stagePolygons.forEach(poly => {
          if (poly.storeData && poly.storeData.polyName) {
            stages.push(poly.storeData.polyName)
          }
        })
      }

      let directionNames = []
      if (this.videoData.directionPolygons && this.videoData.directionPolygons.length > 0) {
        this.videoData.directionPolygons.forEach(poly => {
          if (poly.storeData && poly.storeData.polyName) {
            directionNames.push(poly.storeData.polyName)
          }
        })
      }

      let directionPairs = []
      for (let i = 0; i < directionNames.length; i++) {
        for (let j = 0; j < directionNames.length; j++) {
          if (i !== j) {
            directionPairs.push(directionNames[i] + directionNames[j])
          }
        }
      }

      let combinations = []
      stages.forEach(stage => {
        directionPairs.forEach(direction => {
          let existing = this.videoData.numberOfLanes
            ? this.videoData.numberOfLanes.find(l => l.stage === stage && l.direction === direction)
            : null
          combinations.push({
            stage: stage,
            direction: direction,
            numberOfLanes: existing ? existing.numberOfLanes : 0
          })
        })
      })

      return combinations
    },
  },
  watch: {
    selectedCalibration() {
      console.log('Selected calibration: ', this.selectedCalibration)
      this.convertAndSetData()
      this.parseData(this.storeData)
      this.$refs.mapDraw.setFeature(this.storeData ? this.storeData.geoLines : null)
      this.$refs.mapDraw.setCrossingDistanceFeature(this.storeData ? this.storeData.crossingDistanceGeoLines : null)
      this.$refs.mapDraw.setWorldRectFeature(this.storeData ? this.storeData.worldRectGeoLines : null)
      this.$refs.mapDraw.addOrRemoveDraw()

      if (this.selectedCalibration && this.$refs.videoRef.src !== this.selectedCalibration.videoUrl) {
        this.isLoading = true
        this.videoLoaded = false
        this.$refs.videoRef.src = this.selectedCalibration.videoUrl
      } else if (this.$refs.videoRef.src !== this.selectedDevice.videoUrl) {
        this.isLoading = true
        this.videoLoaded = false
        this.$refs.videoRef.src = this.selectedDevice.videoUrl
      }
    }
  }
}
</script>

<style scoped>
.video-img {
  background: white;
}

.canvas-style {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
}

.shadow {
  box-shadow: 0 0.125em 0.125em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 14%);
}

</style>